import React from "react";

const UserFooter = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="main-footer1">
      <div className="float-end d-none d-sm-block">
        Copyright &copy; {year}. All rights reserved.
      </div>
      Powered By
      <a href="http://www.mindzcube.com" className="ms-2">
        <img src="/img/mindzcube.png" height="30px" alt="Mindzcube" />
      </a>
    </footer>
  );
};

export default UserFooter;
